export const TITLE = 'FUNDING' as const;
export const SUBTITLES = {
    TOTAL_FUNDING: 'Total Funding',
    CURRENT_FUNDING: 'Current Funding',
    FUNDING_SITUATION_DESCRIPTION: 'Funding Situation Description',
    METHODOLOGY_DESCRIPTION: 'Methodology Description',
    FUNDING_CAP_PER_PROJECT: 'Funding Cap per Project',
    FUNDING_CAP_PER_APPLICANT: 'Funding Cap per Applicant',
} as const;
